import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { display } from "styled-system";
import { Backdrop, Block, Divider, Overlay, Portal, Tabs } from "reakit";
import { Box, Button, Flex, Heading, Image, Text } from "rebass";
// import {FloatingButton} from "../Base/Buttons";
import { withFirebase } from "../Firebase";
import { TabHeader } from "../Base";
// import {MapMarkerAlt} from "styled-icons/fa-solid";
import check from "../../resources/img/icons/Checkbox@1x-black.png";

/*
this component is used by:
`pages/RosterDetails/RosterProfile`,
`pages/Profile`,
`components/StudentSummary`,
`components/Sidebar`
*/

const PanelWrapper = styled(Box)`
  //min-width: 250px;
  //	height: calc(100vh - 131px);
  //	margin-bottom: 10px;
  height: calc(60vh - 170px);
  overflow-y: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  @media (max-width: 700px) {
    height: 70vh;
  }
`;

const InlineOrBlock = styled(Box)`
  ${display}
`;
const FixedControls = styled(Box)`
  position: relative;
  bottom: -54px;

  //z-index: 9990;
  width: 100%;
  @media (max-width: 700px) {
    position: relative;
    bottom: -5px;

    //z-index: 9990;
    width: 100%;
  }
`;

// const MapMarker = styled(MapMarkerAlt)`
//   width: 20px;
//   height: 20px;
//   color: white;
// `;
const FilterOverlay = styled(Overlay)`
  width: 50%;
  max-width: 600px;
  height: 60vh;
  @media (max-width: 700px) {
    width: 100%;
    height: 100%;
  }
`;

const textProps = {
  ml: 3,
};

// This Wavepopup component is used in the Sidebar and Mobile Profile
class WavePopup extends Component {
  state = {
    onLeave: false,
    leaveType: null,
    current: null,
    locations: [],
    history: [],
  };

  componentDidMount() {
    const { school } = this.props;
    this.setState({
      locations: school.locations.list,
    });
    //this.fetchLocationList();
    // const {student} = this.props;
    // if(student.current_location){
    //   this.setState({current: student.current_location})
    // }
    this.listener = this.returnStudentListner();
  }

  returnStudentListner = () => {
    const { student } = this.props;

    return this.props.firebase.student(student.id).onSnapshot((snapshot) => {
      let data = snapshot.data();
      if (data.hasOwnProperty("current_location")) {
        if (data.on_leave === true) {
          this.setState({ onLeave: true, leaveType: student.leave_type });
        } else {
          this.setState({ current: data.current_location });
        }
      }
    });
  };

  handleSelect = (location, toggle) => {
    // console.log('selected', location);
    const { isFaculty, student, profile } = this.props;
    if (isFaculty) {
      // todo
      let studentRef = this.props.firebase.student(student.id);
      let waveRef = studentRef.collection("wave_history");
      waveRef.add({
        creator_uid: profile.id,
        location_is_geowave: false,
        location_uid: location.id,
        post_time: Math.floor(Date.now() / 1000),
      });
      studentRef.update({
        current_location: location.id,
      });
      // this.setState({current: location.id})

      toggle();
    } else {
      let studentRef = this.props.firebase.student(student.id);
      let waveRef = studentRef.collection("wave_history");
      let newWave = waveRef.doc();
      newWave.set({
        creator_uid: profile.id,
        location_is_geowave: false,
        location_uid: location.id,
        post_time: Math.floor(Date.now() / 1000),
      });
      studentRef.update({
        current_location: location.id,
      });
      // this.setState({current: location.id})

      toggle();
    }
  };

  componentWillUnmount() {
    this.listener();
  }

  handleSignin = async () => {
    const { firebase, student, isFaculty, profile } = this.props;
    if (isFaculty) {
      try {
        let leaveId = student.leaves.filter((item) => item.status === 11)[0];
        let studentRef = firebase.student(student.id);
        studentRef.update({
          on_leave: false,
          leave_type: null,
          current_location: "WmvfYHXXazFfBYnyej2Y",
        });

        let waveRef = studentRef.collection("wave_history");
        let newWave = waveRef.doc();
        newWave.set({
          creator_uid: profile.id,
          location_is_geowave: false,
          location_uid: "WmvfYHXXazFfBYnyej2Y",
          post_time: Math.floor(Date.now() / 1000),
        });
        if (leaveId) {
          let leavesRef = firebase.leave(leaveId.id);
          leavesRef.update({
            status: 12,
          });
        }
        this.setState({ onLeave: false });
      } catch (error) {
        //console.log(error);
      }
    }
  };

  render() {
    const { locations, current, onLeave, leaveType } = this.state;
    const { school, hideLocation, studentSummary, isFaculty } = this.props;
    let location = "";
    if (onLeave === true && leaveType !== null) {
      location =
        school.leaveTypes[leaveType] && school.leaveTypes[leaveType].name;
    } else if (current !== null) {
      const locationData = locations.filter(
        (location) => location.id === current
      );
      if (locationData.length > 0) {
        location = `${locationData[0].is_oncampus ? "ON - " : "OFF - "}${
          locationData[0].name
        }`;
      }
    }

    return (
      <Overlay.Container>
        {(overlay) => (
          <InlineOrBlock display={hideLocation ? "inline-block" : "block"}>
            {hideLocation ? (
              <FixedControls pr={2}>
                {studentSummary && onLeave && isFaculty ? (
                  <Button
                    variant="main"
                    bg={"purple"}
                    onClick={this.handleSignin}
                    {...overlay}
                  >
                    Sign In
                  </Button>
                ) : (
                  <Button
                    variant="main"
                    bg={onLeave ? "gray" : "purple"}
                    disabled={onLeave}
                    onClick={overlay.show}
                    {...overlay}
                  >
                    Wave{" "}
                  </Button>
                )}
              </FixedControls>
            ) : (
              <Flex flexDirection={"column"} flexWrap={"wrap"}>
                <Box pb={1}>
                  <Text mb={2} textAlign="center" color={"meta"}>
                    {location}
                  </Text>
                </Box>
                <Box mt={1}>
                  <Button
                    variant="main"
                    bg={onLeave ? "gray" : "purple"}
                    disabled={onLeave}
                    onClick={overlay.show}
                    {...overlay}
                  >
                    Wave{" "}
                  </Button>
                </Box>
              </Flex>
            )}
            <Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
            <FilterOverlay use={Portal} {...overlay}>
              {/*<FloatingButton><MapMarker/>*/}

              {/*</FloatingButton>*/}
              <Box>
                <Text onClick={overlay.hide}>X</Text>
                <Heading>{location}</Heading>
                <Block>
                  <Tabs.Container>
                    {(tabs) => (
                      <Block>
                        <Tabs>
                          <Tabs.Tab tab="on" {...tabs}>
                            <TabHeader title={"ON"} />
                          </Tabs.Tab>
                          <Tabs.Tab tab="off" {...tabs}>
                            <TabHeader title={"OFF"} />
                          </Tabs.Tab>
                        </Tabs>
                        <Tabs.Panel tab="on" {...tabs}>
                          <PanelWrapper>
                            <Divider />
                            {locations
                              .filter((item) => item.is_oncampus)
                              .map((location) =>
                                location.activated ? (
                                  <Box
                                    key={location.id}
                                    onClick={() =>
                                      this.handleSelect(location, overlay.hide)
                                    }
                                  >
                                    <Flex>
                                      <Box>
                                        <Text {...textProps}>
                                          {location.name}
                                        </Text>
                                      </Box>
                                      <Box ml={"auto"} />
                                      <Box pr={2}>
                                        {current === location.id && (
                                          <Image src={check} />
                                        )}
                                      </Box>
                                    </Flex>
                                    <Box width={1}>
                                      <Divider />
                                    </Box>
                                  </Box>
                                ) : (
                                  ""
                                )
                              )}
                          </PanelWrapper>
                        </Tabs.Panel>
                        <Tabs.Panel tab="off" {...tabs}>
                          <PanelWrapper>
                            <Divider />
                            {locations
                              .filter((item) => !item.is_oncampus)
                              .map((location) =>
                                location.activated ? (
                                  <Box
                                    key={location.id}
                                    onClick={() =>
                                      this.handleSelect(location, overlay.hide)
                                    }
                                  >
                                    <Flex>
                                      <Box>
                                        <Text {...textProps}>
                                          {location.name}
                                        </Text>
                                      </Box>
                                      <Box ml={"auto"} />
                                      <Box pr={2}>
                                        {current === location.id && (
                                          <Image src={check} />
                                        )}
                                      </Box>
                                    </Flex>
                                    <Box width={1}>
                                      <Divider />
                                    </Box>
                                  </Box>
                                ) : (
                                  ""
                                )
                              )}
                          </PanelWrapper>
                        </Tabs.Panel>
                      </Block>
                    )}
                  </Tabs.Container>
                </Block>
              </Box>
            </FilterOverlay>
          </InlineOrBlock>
        )}
      </Overlay.Container>
    );
  }
}

WavePopup.propTypes = {
  hideLocation: PropTypes.bool,
};

WavePopup.defaultProps = {
  hideLocation: false,
};

export default withFirebase(WavePopup);
